import { TenantProvider } from '~/tenants/common/TenantPersona';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVideoConfig from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmFloorplanConfig from '~/tenants/mcm/performable/floorplan/McmFloorplanConfig';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmMatterportConfig from '~/tenants/mcm/performable/matterport/McmMatterportConfig';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';

export enum McmProviderId {
  TOM_RUOCCO = 1,
  JOYCE_DAYAN = 2,
  SEAN_FITZGERALD = 3,
  ANTHONY_PORTO = 4,
  HOWIE_COHEN = 5,
  CHAD_MOONEY = 6,
  CHAD_MARTIN = 7,
  ERICA_YELO = 8,
  JACQUELINE_SOKOLOFF = 9,
  DYLAN_JONES = 10,
  STEPHEN_MORAUX = 11,
  NADIA_ITANI = 12,
  DAN_GILLESPIE = 13,
  LARRY_BERKO = 14,
  KIMBERLY_PETERS = 15,
  STANTON_HUNTER = 16,
  JOE_PERRI = 17,
  TADHG_BRADY = 18,
  //KARTHEEK_HEDGE = 19,
  ADAM_SMITHEIMER = 20,
  DAN_FITZPATRICK = 21,
  BARTLETT_LENTINI = 22,
  //KEVIN_NEHRBAUER = 23
  FRANK_ZRINSKY = 24
}

export interface McmProviderStaticData {
  photos?: boolean;
  drone_stills?: boolean;
  drone_video?: boolean;
  video?: boolean;
  floorplan?: boolean;
  zillow?: boolean;
  matterport?: boolean;
  event?: boolean;
}

export default class McmProvider extends TenantProvider<McmProviderStaticData> {
  get performableIds(): string[] {
    const ids: string[] = [];

    if (this.config.photos) {
      ids.push(McmPhotoConfig.id);
    }

    if (this.config.drone_stills || this.config.drone_video || this.offersFromProfile(McmDroneConfig.id)) {
      ids.push(McmDroneConfig.id);
    }

    if (this.config.video) {
      ids.push(McmVideoConfig.id);
    }

    if (this.config.floorplan) {
      ids.push(McmFloorplanConfig.id);
    }

    if (this.config.zillow) {
      ids.push(McmZillowConfig.id);
    }

    if (this.config.matterport) {
      ids.push(McmMatterportConfig.id);
    }

    return ids;
  }

  canPerform(context: McmOrderContext, job: McmOrderContext['jobs'][0]): true | string {
    const parent = super.canPerform(context, job);

    if (parent !== true) {
      return parent;
    }

    if (job.performable_id === McmDroneConfig.id) {
      // A DB-only provider has no stills/video split: ticking Drone covers both.
      const profileDrone = this.offersFromProfile(McmDroneConfig.id);

      if (
        !this.config.drone_stills &&
        !profileDrone &&
        [McmDroneType.PHOTO, McmDroneType.VIDEO_PHOTO].includes(job.metadata.type)
      ) {
        return 'This provider does not do drone stills.';
      }

      if (!this.config.drone_video && !profileDrone && job.metadata.type !== McmDroneType.PHOTO) {
        return 'This provider does not do drone video.';
      }
    }

    return true;
  }
}
